<template>
  <Card v-if="loaded" :padding="0">
    <p slot="title">Заявки</p>
    <Modal
      :mask-closable="false"
      title="Рассмотрение заявки"
      v-model="modal"
      v-on:on-visible-change="handleVisibleChange"
    >
      <div slot="footer" v-if="!!element && !element.status">
        <Input
          v-model="message"
          type="textarea"
          :autosize="{minRows: 3}"
          placeholder="Сообщение пользователю"
        />
        <div class="modal-buttons-container">
          <Button 
            type="error" 
            v-on:click="() => handleApproval('error')"
          >
            Отклонить
          </Button>
          <Button
            type="success"
            v-on:click="() => handleApproval('success')"
          >
            Одобрить
          </Button>
        </div>
      </div>

      <div v-if="!!element" class="modal-info">
        <p>Имя: <b>{{`${element.user.data.surname} ${element.user.data.name}`}}</b></p>
        <p>Дата рождения: <b>{{element.user.data.birthdate}}</b></p>
        <p>Специальность: <b>{{`${element.specialtyName}`}}</b></p>
        <p class="label">
          Достижения
        </p>
        <div
          class="modal-item"
          v-for="element in element.user.achievements"
          :key="element.id"
        >
          <p>
            <a
              target="_blank" 
              rel="noopener noreferrer" 
              :href="element.files && element.files[0].url"
            >
              {{element.name}} - {{element.achievement}}
            </a>
          </p>
          <p>{{element.date}}</p>
        </div>
        <p class="label">
          Прикрепленные документы
        </p>
        <div
          class="modal-item"
          v-for="(element, index) in element.files"
          :key="`file ${index}`"
        >
          <a
            target="_blank" 
            rel="noopener noreferrer" 
            :href="element.url"
          >
            {{element.title}}
          </a>
        </div>
        <div v-if="!!element.status">
          <p class="label">
            Статус заявки
          </p>
          <div
            class="modal-item"
          >
            <span v-if="element.status === 'success'">
              Одобрено
            </span>
            <span v-else-if="element.status === 'error'">
              Отклонено
            </span>
          </div>
          <p class="label">
            Сообщение пользователю
          </p>
          <div
            class="modal-item"
          >
            {{element.message}}
          </div>
        </div>
      </div>
    </Modal>
    <div class="search-container">
      <Input
        search
        enter-button
        placeholder="Поиск"
        v-on:on-search="handleSearch"
      />
    </div>
    <div>
      <div
        class="element"
        v-for="(element) in elements"
        :key="element.id"
        v-on:click="() => handleElementClick(element)"
      >
        <div>
          <p class="name">
            {{`${element.user.data.surname} ${element.user.data.name}`}}
          </p>
          <p>Специальность: <b>{{`${element.specialtyName}`}}</b></p>
        </div>
        <div class="element-right">
          {{element.date}}
          <div v-if="!!element.status">
            <Icon
              v-if="element.status === 'success'"
              type="ios-checkmark"
              size="30"
              style="color:#5cb85c"
            />
            <Icon 
              v-else-if="element.status === 'error'"
              type="ios-close" 
              size="30" 
              style="color:#ff5500"
            />
          </div>
        </div>
      </div>
    </div>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';

export default {
  data() {
    return {
      id: null,
      institution: null,
      loaded: false,
      modal: false,
      data: [],
      elements: [],
      element: null,
      message: null
    }
  },
  async mounted() {
    const email = firebase.auth().currentUser.email;

    const ref = firebase.database().ref(`institutions`)
    .orderByChild('admin').equalTo(email);
    const snapshot = await ref.once('value');
    const array = [];
    
    snapshot.forEach(childSnapshot => {
      const element = childSnapshot.val();
      element.id = childSnapshot.key;
      array.push(element);
    });
    
    if(array.length > 0) {
      const institution = array[0];

      if(!institution.active) {
        await firebase.auth().signOut();

        this.$router.push('/auth');
      }

      this.institution = institution.id;

      try {
        const ref = firebase.database().ref(`admissions`)
        .orderByChild('institution').equalTo(this.institution);
        const snapshot = await ref.once('value');
        const array = [];

        snapshot.forEach(childSnapshot => {
          const element = childSnapshot.val();

          element.id = childSnapshot.key;

          const date = new Date(element.timestamp);
          const months = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентебря', 'Октября', 'Ноября', 'Декабря'];

          const dd = date.getDate();
          const mm = months[date.getMonth()];
          const yyyy = date.getFullYear();

          element.date = dd + ' ' + mm + ' ' + yyyy + ' года';
              
          array.push(element);
        });

        const users = new Map();

        for (let i = 0; i < array.length; i++) {
          const element = array[i];

          if(!users.has(element.uid)) {
            const userRef = firebase.database()
            .ref(`users/${element.uid}`);
            const userSnapshot = await userRef.once('value');
            const user = userSnapshot.val();

            const achievements = [];
            for (var prop in user.achievements) {
              const achievement = user.achievements[prop];
              achievement.id = prop;
              achievements.push(achievement);
            }
            user.achievements = achievements;

            users.set(element.uid, user);
          }

          element.user = users.get(element.uid);
        }

        array.sort(function(x, y) {
          return (x.status === y.status)? 0 : x.status? 1 : -1;
        });

        this.data = array;
        this.elements = array;
      }
      catch(error) {

      }
    }

    this.loaded = true;
  },
  methods: {
    handleSearch(value) {
      const target = value.toLowerCase();

      this.elements = this.data.filter(e => {
        const surname = e.user.data.surname.toLowerCase();

        return (surname.startsWith(target));
      });
    },
    handleElementClick(element) {
      this.element = element;
      this.modal = true;
    },
    handleVisibleChange(value) {
      if(!value) {
        setTimeout(() => {
          this.message = null;
          this.element = null;
        }, 300);
      }
    },
    async handleApproval(status) {
      if(!this.message) {
        this.$Message.error("Необходимо написать сообщение");
        return;
      }

      if(status === 'error') {
        const confirm = await new Promise(resolve => 
        this.$Modal.confirm({
          title: 'Отклонение',
          content: "Вы уверены, что хотите отклонить?",
          onOk: () => resolve(true),
          onCancel: () => resolve(false)
        }))

        if(!confirm) return;
      }
      else if(status === 'success') {
        const confirm = await new Promise(resolve => 
        this.$Modal.confirm({
          title: 'Одобрение',
          content: "Вы уверены, что хотите одобрить?",
          onOk: () => resolve(true),
          onCancel: () => resolve(false)
        }))

        if(!confirm) return;
      }

      const path = `admissions/${this.element.id}`;
      const ref = firebase.database().ref(path);

      await ref.update({
        status: status,
        message: this.message
      });

      this.element.status = status;
      this.element.message = this.message;

      this.$Message.success("Успешно отправлено");

      this.modal = false;
    }
  }
}
</script>

<style scoped>
.root {
  width: 100%;
  height: 100%;
}
.modal-buttons-container {
  margin-top: 12px;
}
.label {
  font-weight: bold;
  font-size: 12px;
  margin-top: 6px;
}
.modal-item {
  line-height: 24px;
}
.modal-info {
  font-size: 14px;
  line-height: 2;
}
.element:first-child {
  padding-top: 0;
}
.element {
  cursor: pointer;

  padding: 16px;
  border-bottom: 1px solid #e8eaec;

  font-size: 14px;

  display: flex;
  justify-content: space-between;
}
.element-right {
  text-align: right;
}
.name {
  font-size: 18px;
}

.icons-container {
  min-width: 56px;
}
.icon {
  cursor: pointer;
  margin: 4px;
}
.inline-block {
  width: 100%; 
  display: inline-block;
}
.deletable-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trash {
  cursor: pointer;
  padding-left: 10px;
  padding-right: 4px;
}
.search-container {
  padding: 16px;
}
</style>